import parentImage1 from "/images/avatars/testimonial_amanda.png"
import parentImage3 from "/images/avatars/testimonial_mark.png"
import parentImage2 from "/images/avatars/testimonial_sabrina.png"
import parentReferralImage1 from "/images/avatars/testimonial_jamie.png"
import parentReferralImage2 from "/images/avatars/testimonial_lucy.png"
import parentReferralImage3 from "/images/avatars/testimonial_megan.png"
import parentReferralImage4 from "/images/avatars/testimonial_nick.png"
import parentReferralImage5 from "/images/avatars/testimonial_charlotte.png"
import reminderImage from "/images/prepaywall/reminder.png"
import motivationImage from "/images/prepaywall/motivation.png"
import energyImage from "/images/prepaywall/energy.png"
import completionImage from "/images/prepaywall/completion.png"

import {
  faFamily,
  faFaceSmileHearts,
  faGift,
  faFaceSmileHorns,
  faFaceAnxiousSweat,
  faFaceDotted,
  faPersonHarassing,
  faScalpelLineDashed,
  faVenusMars,
  faJoint,
  faHandFist,
  faFaceSwear,
  faThoughtBubble,
  faPalette,
  faHandshake,
  faFaceViewfinder,
  faChartSimple,
  faHeartCrack,
  faHeart,
  faHeadSideGear,
  faPaintBrush,
  faComment,
  faHandHoldingHeart,
  faPartyHorn,
  faUnlock,
  faBullseyeArrow,
} from "@fortawesome/duotone-light-svg-icons"
import {
  DoterSpecies,
  DropdownOption,
  Gender,
  JoonColorExpanded,
  QuestRoutine,
  QuestStatus,
} from "@joonapp/web-shared"
import dayjs from "dayjs"

import focus from "./images/icons/focus-icon@2x.png"
import kindness from "./images/icons/kindness-icon@2x.png"
import knowledge from "./images/icons/knowledge-icon@2x.png"
import morning from "./images/icons/morning-routine-icon@2x.png"
import stamina from "./images/icons/stamina-icon@2x.png"
import strength from "./images/icons/strength-icon@2x.png"
import { AIPromptFlag, CancellationSurveyType, GreenFlag } from "./types"
import { CancellationSurveyQuestion } from "./types"
import { CoachingLookupKey } from "./types/coachingGroups"
import { QuestTemplateCategory } from "./types/quests"
import { displayStringForTemplateCategory } from "./util/choices/quests"

export const SKILL_MAPPING = {
  knowledge: "Learning & Education",
  stamina: "Mental Health",
  strength: "Health & Fitness",
  kindness: "Relationship Building",
  focus: "Focus & Self Control",
  teamwork: "Chores & Housework",
} as { [key: string]: string }

export const SKILL_DROPDOWN = Object.entries(SKILL_MAPPING).map(
  ([key, value]) => ({
    label: value,
    value: key,
  })
)

export const DAY_INDEX_MAP = {
  monday: 0,
  tuesday: 1,
  wednesday: 2,
  thursday: 3,
  friday: 4,
  saturday: 5,
  sunday: 6,
} as const

export const REPETITIONS = {
  daily: [true, true, true, true, true, true, true],
  noDays: [false, false, false, false, false, false, false],
  weekdays: [false, true, true, true, true, true, false],
  weekends: [true, false, false, false, false, false, true],
}

export enum RecurrenceOption {
  EVERY_DAY,
  WEEKDAYS,
  WEEKENDS,
  WEEKLY_TODAY,
  CUSTOM,
}

export enum StartDateOption {
  TODAY,
  TOMORROW,
  CUSTOM,
}

export const anytimeToggleOptions: DropdownOption[] = [
  { label: "Anytime", value: "anytime" },
  { label: "Time of Day", value: "time-of-day" },
]

export const RECURRENCE_OPTIONS: DropdownOption[] = [
  {
    label: "Every day",
    value: RecurrenceOption.EVERY_DAY,
  },
  {
    label: "Weekdays",
    value: RecurrenceOption.WEEKDAYS,
  },
  {
    label: "Weekends",
    value: RecurrenceOption.WEEKENDS,
  },
  {
    label: `Every week on ${dayjs().format("ddd")}`,
    value: RecurrenceOption.WEEKLY_TODAY,
  },
  {
    label: "Custom...",
    value: RecurrenceOption.CUSTOM,
  },
]

export const timerMinuteOptions = Array.from({ length: 60 }, (_, i) => ({
  value: `${i}`,
  label: `${i} min`,
}))

export const timerSecondOptions = Array.from({ length: 60 }, (_, i) => ({
  value: `${i}`,
  label: `${i} sec`,
}))

export const difficultyRewards = {
  easy: 4,
  medium: 10,
  hard: 20,
}

export const ageGroups = {
  six_under: {
    value: "six_under",
    label: "6 & Under",
  },
  seven_nine: {
    value: "seven_nine",
    label: "7-9",
  },
  ten_twelve: {
    value: "ten_twelve",
    label: "10-12",
  },
  thirteen_up: {
    value: "thirteen_up",
    label: "13 & Over",
  },
}

export const PREFERENCE_KEY = {
  hidesFutureRoutines: "hides_future_routines",
  morningLimit: "morning_limit",
  afternoonLimit: "afternoon_limit",
  nightLimit: "night_limit",
  afternoonStartTime: "afternoon_start_time",
  nightStartTime: "night_start_time",
  enableDoterWishes: "enable_doter_wishes",
  enableDoterChat: "enable_doter_chat",
} as const

export const periodDropdownOptions = [
  {
    label: "All Time",
    value: "all_time",
    endDate: dayjs().format("YYYY-MM-DD"),
    startDate: null,
  },
  {
    label: "This Week",
    value: "this_week",
    endDate: dayjs().format("YYYY-MM-DD"),
    startDate: dayjs().subtract(7, "day").format("YYYY-MM-DD"),
  },
  {
    label: "This Month",
    value: "this_month",
    endDate: dayjs().format("YYYY-MM-DD"),
    startDate: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
  },
  {
    label: "Custom",
    value: "custom",
    endDate: dayjs().format("YYYY-MM-DD"),
    startDate: null,
  },
]
export type PeriodDropdownOption = (typeof periodDropdownOptions)[number]

export const templateCategoryDropdownOptions = Object.values(
  QuestTemplateCategory
).map((category) => ({
  value: category,
  label: displayStringForTemplateCategory(category),
}))

export const parentQuestItems = [
  {
    icon: faFaceSmileHearts,
    title: "Lead by example and get in on the fun",
    description:
      "Create quests for yourself, lead your family by example, and earn coins when you do your quests!",
  },
  {
    icon: faGift,
    title:
      "Use earned coins to send surprise gifts straight to your kid's game!",
    description:
      "Send your kid accessories they can use in their Joon App Game and get extra parent brownie points!",
  },
  {
    icon: faFamily,
    title: "Families that quest together, stay together",
    description: "Collaborate together and keep each other accountable!",
  },
]

export const openQuestStatuses = [QuestStatus.OPEN, QuestStatus.RETRY]

export const completeQuestStatuses = [
  QuestStatus.COMPLETED,
  QuestStatus.REDEEMED,
  QuestStatus.VERIFIED,
]

export const rejectedQuestStatuses = [
  QuestStatus.REJECTED,
  QuestStatus.REJECTED_VIEWED,
]

export enum QUERY_KEYS {
  CAMPAIGN_PLANS = "campaign-plans",
  QUEST_BOARD = "quest-board",
  ALL_QUESTS = "all-quests",
  QUEST_INSTANCE_STATS = "quest-instance-stats",
  QUEST_REVIEW = "quest-review",
  QUEST_LOG = "quest-log",
  QUESTIONNAIRES = "questionnaires",
  CARE_TEAM = "care-team",
  COACH_INTAKE_FORM = "coach-intake-form",
  COACH_ONBOARD_INTAKE_FORM = "coach-onboard-intake-form",
  COACH_POST_SELECTION = "coach-post-selection",
  COACH_PROFILES = "coach-profiles",
  COACH_SUMMARY = "coach-summary",
  RECOMMENDATION_QUESTIONNAIRES = "recommendation-questionnaires",
  REFERRAL_INFO = "referral-info",
  USER = "user",
  FAMILY = "family",
  FAMILY_MAIL = "family-mails",
  UNREAD_MAIL = "family-unread-mails",
  INVENTORY = "inventory-items",
  PARENT_SHOP = "parent-shop",
  SUBSCRIBER_INFO = "subscriber-info",
  CHILD_AUTH_CODE = "child-auth-code",
  PARENT_AUTH_CODE = "parent-auth-code",
  CUSTOM_REWARDS = "custom-rewards",
  CUSTOM_REWARD_LOGS = "custom-reward-logs",
  CUSTOM_REWARD_LOGS_STATS = "custom-reward-logs-stats",
  REWARD_TEMPLATES = "reward-templates",
  ONBOARDING_REWARD_TEMPLATES = "onboarding-reward-templates",
  QUEST_TEMPLATES = "quest-templates",
  NOTIFICATION_PREFERENCES = "notification-preferences",
  SB_CREDENTIALS = "sb-credentials",
  THERAPISTS = "therapists",
  THERAPIST_INVITES = "therapist-invites",
  EXPERIMENTS = "experiments",
  BONUS_REWARDS = "bonus-rewards",
  AVERAGE_COINS_EARNED_THIS_WEEK = "average-coins-earned-this-week",
  COIN_TRANSACTIONS = "coin-transactions",
  COIN_CUMULATIVE_STATS = "coin-cumulative-stats",
  NETWORK_INFO = "network-info",
  COUNTRY_CODE = "country-code",
  PARENT_TASKS = "parent-tasks",
  PARENT_TASK_INSTANCES = "parent-task-instances",
  INCIDENT_TEMPLATES = "incident-templates",
  TRAININGS = "trainings",
  FAMILY_CHECKOUT_LINK = "family-checkout-link",
  SUBSCRIPTION_PACKAGES = "subscription-packages",
  COACH_SUBSCRIPTION = "coach-subscription",
  SESSION_BILLING_PERIODS = "session-billing-periods",
  SESSION_BOOKINGS = "session-bookings",
  COACHING_GROUPS = "coaching-groups",
  SESSION_BOOKING = "session-booking",
  CUSTOM_REWARD_BALANCES = "custom-reward-balances",
  SCREEN_TIME_BALANCES = "screen-time-balances",
  AGREEMENT_LINKS = "agreement-links",
  PRIVACY_POLICY_AGREEMENT_LINKS = "privacy-policy-agreement-links",
  DOTER_CHAT_LOGS = "doter-chat-logs",
  FLAGGED_DOTER_CHAT_LOGS = "flagged-doter-chat-logs",
  COINS_READY_TO_REDEEM = "coins-ready-to-redeem",
  RECENT_MAIL = "recent-mail",
  MISSIONS = "missions",
  ME_TAB_CARD = "me-tab-card",
  SCREEN_TIME_CURRENT_EXCEPTION = "screen-time-current-exception",
  SCREEN_TIME_SCHEDULED_EXCEPTIONS = "screen-time-scheduled-exceptions",
  SCREEN_TIME_MANUAL_EXCEPTIONS = "screen-time-manual-exceptions",
  SCREEN_TIME_ACTIVE_SESSION = "screen-time-active-session",
  CANCEL_FLOW = "cancel-flow",
  PLANNED_EVENTS = "planned-events",
}

export const questRoutineOptions: DropdownOption[] = [
  {
    label: "All",
    value: null,
  },
  {
    label: "Morning",
    value: QuestRoutine.MORNING,
  },
  {
    label: "Afternoon",
    value: QuestRoutine.AFTERNOON,
  },
  {
    label: "Night",
    value: QuestRoutine.NIGHT,
  },
  {
    label: "Anytime",
    value: QuestRoutine.ANYTIME,
  },
]

export const GRADIENTS = {
  gradient100: `linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.8) 2.83%,
    rgba(255, 255, 255, 0) 51.53%,
    rgba(255, 255, 255, 0.8) 99.81%
  ),
  #e9eafa`,
}

export const BACKGROUND_COLORS = {
  xlightBlueBg: "#f7fbfe",
  lightBlueBg: "#f3f9fd",
}

export const GENDER_OPTIONS = [
  { label: "Girl", value: Gender.FEMALE },
  { label: "Boy", value: Gender.MALE },
  { label: "Prefer not to answer", value: Gender.OTHER },
]

export const COACH_PLANS = {
  [CoachingLookupKey.TEXT_ONLY]: {
    plan: "Starter",
    frequency: null,
  },
  [CoachingLookupKey.ONE_CALL]: {
    plan: "Basic",
    frequency: "1x flexible session with your coach/month",
  },
  [CoachingLookupKey.STANDARD]: {
    plan: "Plus",
    frequency: "2x flexible sessions with your coach/month",
  },
  [CoachingLookupKey.THREE_CALLS]: {
    plan: "Plus",
    frequency: "3x flexible sessions with your coach/month",
  },
  [CoachingLookupKey.FOUR_CALLS]: {
    plan: "Pro",
    frequency: "4x flexible sessions with your coach/month",
  },
  [CoachingLookupKey.COACHING_DEV]: {
    plan: "Dev",
    frequency: "Standard plan. You should only see this if you're a dev.",
  },
}

export const CoachingQuestionText = {
  [CancellationSurveyType.COACH]: {
    [CancellationSurveyQuestion.WHY_LEAVING]:
      "Why didn't coaching work for you?",
    [CancellationSurveyQuestion.ALTERNATIVE_SOLUTIONS]:
      "What will you use going forward for parenting resources?",
  },
  [CancellationSurveyType.FAMILY]: {
    [CancellationSurveyQuestion.WHY_LEAVING]: "Why didn't Joon work for you?",
    [CancellationSurveyQuestion.ALTERNATIVE_SOLUTIONS]:
      "What will you use going forward to motivate your child?",
  },
} as const

export enum CoachPaywallChoice {
  WITH_COACH = "withCoach",
  EXIT_WITH_COACH = "exitWithCoach",
  APP_ONLY = "appOnly",
}

export enum ScreenTimeControlsModalStep {
  ANNOUNCEMENT,
  INTRO,
  SETUP_PASSCODE,
  DEVICE_SELECTION,
  SETUP_JOONITY,
  FINISH,
}

export enum ScreenTimeControlsAnalyticsStep {
  SETUP_PASSCODE = "setup_passcode",
  DEVICE_SELECTION = "device_selection",
  SETUP_JOONITY = "setup_joonity",
  FINISH = "finish",
}

export const DoterChatFlagContent = {
  [AIPromptFlag.BULLYING]: {
    icon: faFaceSmileHorns,
    color: JoonColorExpanded.orange400,
    text: "Bullying",
  },
  [AIPromptFlag.ANXIETY]: {
    icon: faFaceAnxiousSweat,
    color: JoonColorExpanded.blue500,
    text: "Anxiety",
  },
  [AIPromptFlag.DEPRESSION]: {
    icon: faFaceDotted,
    color: JoonColorExpanded.indigo600,
    text: "Depression",
  },
  [AIPromptFlag.ABUSE]: {
    icon: faPersonHarassing,
    color: JoonColorExpanded.pink600,
    text: "Abuse",
  },
  [AIPromptFlag.SELF_HARM]: {
    icon: faScalpelLineDashed,
    color: JoonColorExpanded.red500,
    text: "Self harm",
  },
  [AIPromptFlag.SEXUAL_CONTENT]: {
    icon: faVenusMars,
    color: JoonColorExpanded.pink700,
    text: "Sexual content",
  },
  [AIPromptFlag.SUBSTANCE]: {
    icon: faJoint,
    color: JoonColorExpanded.orange600,
    text: "Substance",
  },
  [AIPromptFlag.VIOLENCE]: {
    icon: faHandFist,
    color: JoonColorExpanded.neutral600,
    text: "Violence",
  },
  [AIPromptFlag.PROFANITY]: {
    icon: faFaceSwear,
    color: JoonColorExpanded.blue700,
    text: "Profanity",
  },
  // all green flags are viridian300
  [GreenFlag.GROWTH]: {
    icon: faChartSimple,
    color: JoonColorExpanded.viridian300,
    text: "Growth",
  },
  [GreenFlag.EMPATHY_KINDNESS]: {
    icon: faHandHoldingHeart,
    color: JoonColorExpanded.viridian300,
    text: "Empathy & Kindness",
  },
  [GreenFlag.GRIEF_LOSS]: {
    icon: faHeartCrack,
    color: JoonColorExpanded.viridian300,
    text: "Grief & Loss",
  },
  [GreenFlag.FAMILY_CONNECTION]: {
    icon: faHeart,
    color: JoonColorExpanded.viridian300,
    text: "Family Connection",
  },
  [GreenFlag.FRIENDSHIP_BELONGING]: {
    icon: faHandshake,
    color: JoonColorExpanded.viridian300,
    text: "Friendship & Belonging",
  },
  [GreenFlag.RESILIENCE]: {
    icon: faHandFist,
    color: JoonColorExpanded.viridian300,
    text: "Resilience",
  },
  [GreenFlag.IDENTITY_PRIDE]: {
    icon: faFaceViewfinder,
    color: JoonColorExpanded.viridian300,
    text: "Identity & Pride",
  },
  [GreenFlag.DEEP_CURIOSITY]: {
    icon: faHeadSideGear,
    color: JoonColorExpanded.viridian300,
    text: "Deep Curiosity",
  },
  [GreenFlag.EMOTIONAL_INSIGHT]: {
    icon: faThoughtBubble,
    color: JoonColorExpanded.viridian300,
    text: "Emotional Insight",
  },
  [GreenFlag.CREATIVE_BREAKTHROUGH]: {
    icon: faPalette,
    color: JoonColorExpanded.viridian300,
    text: "Creative Breakthrough",
  },
  [GreenFlag.ARTISTIC_EXPRESSION]: {
    icon: faPaintBrush,
    color: JoonColorExpanded.viridian300,
    text: "Artistic Expression",
  },
  [GreenFlag.DISCUSSION_TOPIC]: {
    icon: faComment,
    color: JoonColorExpanded.viridian300,
    text: "Discussion Topic",
  },
}

export const userIcons = {
  1: stamina,
  2: morning,
  3: focus,
  4: strength,
  5: kindness,
  6: knowledge,
  8: stamina,
  9: morning,
  10: focus,
  11: strength,
  12: kindness,
  13: knowledge,
} as any

export const parentAvatarImages = {
  [DoterSpecies.DRAGON]: [
    "/images/parentDoterAssets/Red_Body.png",
    "/images/parentDoterAssets/Shirt_Joon.png",
    "/images/parentDoterAssets/Amborn_Red_Head.png",
  ],
  [DoterSpecies.BEAR]: [
    "/images/parentDoterAssets/Blue_Body.png",
    "/images/parentDoterAssets/Shirt_Joon.png",
    "/images/parentDoterAssets/Polair_Blue_Head.png",
  ],
  [DoterSpecies.FOX]: [
    "/images/parentDoterAssets/Ferox_Green_Head_Hair.png",
    "/images/parentDoterAssets/Green_Body.png",
    "/images/parentDoterAssets/Shirt_Joon.png",
    "/images/parentDoterAssets/Ferox_Green_Head.png",
  ],
}

export const priorityCountries = [
  { code: "1", flag: "🇺🇸", country: "United States" },
  { code: "1", flag: "🇨🇦", country: "Canada" },
  { code: "7", flag: "🇷🇺", country: "Russia" },
  { code: "7", flag: "🇰🇿", country: "Kazakhstan" },
  { code: "44", flag: "🇬🇧", country: "United Kingdom" },
  { code: "61", flag: "🇦🇺", country: "Australia" },
  { code: "64", flag: "🇳🇿", country: "New Zealand" },
  { code: "91", flag: "🇮🇳", country: "India" },
]

export const countryCodeList = [
  { code: "1", flag: "🇺🇸", country: "United States" },
  { code: "1", flag: "🇨🇦", country: "Canada" },
  { code: "7", flag: "🇷🇺", country: "Russia" },
  { code: "7", flag: "🇰🇿", country: "Kazakhstan" },
  { code: "20", flag: "🇪🇬", country: "Egypt" },
  { code: "27", flag: "🇿🇦", country: "South Africa" },
  { code: "30", flag: "🇬🇷", country: "Greece" },
  { code: "31", flag: "🇳🇱", country: "Netherlands" },
  { code: "32", flag: "🇧🇪", country: "Belgium" },
  { code: "33", flag: "🇫🇷", country: "France" },
  { code: "34", flag: "🇪🇸", country: "Spain" },
  { code: "36", flag: "🇭🇺", country: "Hungary" },
  { code: "39", flag: "🇮🇹", country: "Italy" },
  { code: "40", flag: "🇷🇴", country: "Romania" },
  { code: "41", flag: "🇨🇭", country: "Switzerland" },
  { code: "43", flag: "🇦🇹", country: "Austria" },
  { code: "44", flag: "🇬🇧", country: "United Kingdom" },
  { code: "45", flag: "🇩🇰", country: "Denmark" },
  { code: "46", flag: "🇸🇪", country: "Sweden" },
  { code: "47", flag: "🇳🇴", country: "Norway" },
  { code: "48", flag: "🇵🇱", country: "Poland" },
  { code: "49", flag: "🇩🇪", country: "Germany" },
  { code: "52", flag: "🇲🇽", country: "Mexico" },
  { code: "53", flag: "🇨🇺", country: "Cuba" },
  { code: "54", flag: "🇦🇷", country: "Argentina" },
  { code: "55", flag: "🇧🇷", country: "Brazil" },
  { code: "56", flag: "🇨🇱", country: "Chile" },
  { code: "57", flag: "🇨🇴", country: "Colombia" },
  { code: "58", flag: "🇻🇪", country: "Venezuela" },
  { code: "61", flag: "🇦🇺", country: "Australia" },
  { code: "62", flag: "🇮🇩", country: "Indonesia" },
  { code: "63", flag: "🇵🇭", country: "Philippines" },
  { code: "64", flag: "🇳🇿", country: "New Zealand" },
  { code: "65", flag: "🇸🇬", country: "Singapore" },
  { code: "66", flag: "🇹🇭", country: "Thailand" },
  { code: "81", flag: "🇯🇵", country: "Japan" },
  { code: "82", flag: "🇰🇷", country: "South Korea" },
  { code: "84", flag: "🇻🇳", country: "Vietnam" },
  { code: "86", flag: "🇨🇳", country: "China" },
  { code: "91", flag: "🇮🇳", country: "India" },
  { code: "92", flag: "🇵🇰", country: "Pakistan" },
  { code: "93", flag: "🇦🇫", country: "Afghanistan" },
  { code: "94", flag: "🇱🇰", country: "Sri Lanka" },
  { code: "95", flag: "🇲🇲", country: "Myanmar" },
  { code: "98", flag: "🇮🇷", country: "Iran" },
  { code: "211", flag: "🇸🇸", country: "South Sudan" },
  { code: "212", flag: "🇲🇦", country: "Morocco" },
  { code: "212", flag: "🇪🇭", country: "Western Sahara" },
  { code: "213", flag: "🇩🇿", country: "Algeria" },
  { code: "216", flag: "🇹🇳", country: "Tunisia" },
  { code: "218", flag: "🇱🇾", country: "Libya" },
  { code: "220", flag: "🇬🇲", country: "Gambia" },
  { code: "221", flag: "🇸🇳", country: "Senegal" },
  { code: "222", flag: "🇲🇷", country: "Mauritania" },
  { code: "223", flag: "🇲🇱", country: "Mali" },
  { code: "224", flag: "🇬🇳", country: "Guinea" },
  { code: "225", flag: "🇨🇮", country: "Ivory Coast" },
  { code: "226", flag: "🇧🇫", country: "Burkina Faso" },
  { code: "227", flag: "🇳🇪", country: "Niger" },
  { code: "228", flag: "🇹🇬", country: "Togo" },
  { code: "229", flag: "🇧🇯", country: "Benin" },
  { code: "230", flag: "🇲🇺", country: "Mauritius" },
  { code: "231", flag: "🇱🇷", country: "Liberia" },
  { code: "232", flag: "🇸🇱", country: "Sierra Leone" },
  { code: "233", flag: "🇬🇭", country: "Ghana" },
  { code: "234", flag: "🇳🇬", country: "Nigeria" },
  { code: "235", flag: "🇹🇩", country: "Chad" },
  { code: "236", flag: "🇨🇫", country: "Central African Republic" },
  { code: "237", flag: "🇨🇲", country: "Cameroon" },
  { code: "238", flag: "🇨🇻", country: "Cape Verde" },
  { code: "239", flag: "🇸🇹", country: "São Tomé and Príncipe" },
  { code: "240", flag: "🇬🇶", country: "Equatorial Guinea" },
  { code: "241", flag: "🇬🇦", country: "Gabon" },
  { code: "242", flag: "🇨🇬", country: "Republic of the Congo" },
  { code: "243", flag: "🇨🇩", country: "Democratic Republic of the Congo" },
  { code: "244", flag: "🇦🇴", country: "Angola" },
  { code: "245", flag: "🇬🇼", country: "Guinea-Bissau" },
  { code: "246", flag: "🇮🇴", country: "British Indian Ocean Territory" },
  { code: "247", flag: "🇸🇭", country: "Ascension Island" },
  { code: "248", flag: "🇸🇨", country: "Seychelles" },
  { code: "249", flag: "🇸🇩", country: "Sudan" },
  { code: "250", flag: "🇷🇼", country: "Rwanda" },
  { code: "251", flag: "🇪🇹", country: "Ethiopia" },
  { code: "252", flag: "🇸🇴", country: "Somalia" },
  { code: "253", flag: "🇩🇯", country: "Djibouti" },
  { code: "254", flag: "🇰🇪", country: "Kenya" },
  { code: "255", flag: "🇹🇿", country: "Tanzania" },
  { code: "256", flag: "🇺🇬", country: "Uganda" },
  { code: "257", flag: "🇧🇮", country: "Burundi" },
  { code: "258", flag: "🇲🇿", country: "Mozambique" },
  { code: "260", flag: "🇿🇲", country: "Zambia" },
  { code: "261", flag: "🇲🇬", country: "Madagascar" },
  { code: "262", flag: "🇷🇪", country: "Réunion" },
  { code: "262", flag: "🇾🇹", country: "Mayotte" },
  { code: "263", flag: "🇿🇼", country: "Zimbabwe" },
  { code: "264", flag: "🇳🇦", country: "Namibia" },
  { code: "265", flag: "🇲🇼", country: "Malawi" },
  { code: "266", flag: "🇱🇸", country: "Lesotho" },
  { code: "267", flag: "🇧🇼", country: "Botswana" },
  { code: "268", flag: "🇸🇿", country: "Eswatini" },
  { code: "269", flag: "🇰🇲", country: "Comoros" },
  { code: "290", flag: "🇸🇭", country: "Saint Helena" },
  { code: "291", flag: "🇪🇷", country: "Eritrea" },
  { code: "297", flag: "🇦🇼", country: "Aruba" },
  { code: "298", flag: "🇫🇴", country: "Faroe Islands" },
  { code: "299", flag: "🇬🇱", country: "Greenland" },
  { code: "350", flag: "🇬🇮", country: "Gibraltar" },
  { code: "351", flag: "🇵🇹", country: "Portugal" },
  { code: "352", flag: "🇱🇺", country: "Luxembourg" },
  { code: "353", flag: "🇮🇪", country: "Ireland" },
  { code: "354", flag: "🇮🇸", country: "Iceland" },
  { code: "355", flag: "🇦🇱", country: "Albania" },
  { code: "356", flag: "🇲🇹", country: "Malta" },
  { code: "357", flag: "🇨🇾", country: "Cyprus" },
  { code: "358", flag: "🇫🇮", country: "Finland" },
  { code: "359", flag: "🇦🇽", country: "Åland Islands" },
  { code: "359", flag: "🇧🇬", country: "Bulgaria" },
  { code: "370", flag: "🇱🇹", country: "Lithuania" },
  { code: "371", flag: "🇱🇻", country: "Latvia" },
  { code: "372", flag: "🇪🇪", country: "Estonia" },
  { code: "373", flag: "🇲🇩", country: "Moldova" },
  { code: "374", flag: "🇦🇲", country: "Armenia" },
  { code: "375", flag: "🇧🇾", country: "Belarus" },
  { code: "376", flag: "🇦🇩", country: "Andorra" },
  { code: "377", flag: "🇲🇨", country: "Monaco" },
  { code: "378", flag: "🇸🇲", country: "San Marino" },
  { code: "379", flag: "🇻🇦", country: "Vatican City" },
  { code: "380", flag: "🇺🇦", country: "Ukraine" },
  { code: "381", flag: "🇷🇸", country: "Serbia" },
  { code: "382", flag: "🇲🇪", country: "Montenegro" },
  { code: "383", flag: "🇽🇰", country: "Kosovo" },
  { code: "385", flag: "🇭🇷", country: "Croatia" },
  { code: "386", flag: "🇸🇮", country: "Slovenia" },
  { code: "387", flag: "🇧🇦", country: "Bosnia and Herzegovina" },
  { code: "389", flag: "🇲🇰", country: "North Macedonia" },
  { code: "420", flag: "🇨🇿", country: "Czech Republic" },
  { code: "421", flag: "🇸🇰", country: "Slovakia" },
  { code: "423", flag: "🇱🇮", country: "Liechtenstein" },
  { code: "500", flag: "🇫🇰", country: "Falkland Islands" },
  { code: "501", flag: "🇧🇿", country: "Belize" },
  { code: "502", flag: "🇬🇹", country: "Guatemala" },
  { code: "503", flag: "🇸🇻", country: "El Salvador" },
  { code: "504", flag: "🇭🇳", country: "Honduras" },
  { code: "505", flag: "🇳🇮", country: "Nicaragua" },
  { code: "506", flag: "🇨🇷", country: "Costa Rica" },
  { code: "507", flag: "🇵🇦", country: "Panama" },
  { code: "508", flag: "🇵🇲", country: "Saint Pierre and Miquelon" },
  { code: "509", flag: "🇭🇹", country: "Haiti" },
  { code: "590", flag: "🇬🇵", country: "Guadeloupe" },
  { code: "591", flag: "🇧🇴", country: "Bolivia" },
  { code: "592", flag: "🇬🇾", country: "Guyana" },
  { code: "593", flag: "🇪🇨", country: "Ecuador" },
  { code: "594", flag: "🇬🇫", country: "French Guiana" },
  { code: "595", flag: "🇵🇾", country: "Paraguay" },
  { code: "596", flag: "🇲🇶", country: "Martinique" },
  { code: "597", flag: "🇸🇷", country: "Suriname" },
  { code: "598", flag: "🇺🇾", country: "Uruguay" },
  { code: "599", flag: "🇨🇼", country: "Curaçao" },
  { code: "599", flag: "🇧🇶", country: "Bonaire, Sint Eustatius and Saba" },
  { code: "670", flag: "🇹🇱", country: "Timor-Leste" },
  { code: "672", flag: "🇦🇶", country: "Antarctica" },
  { code: "672", flag: "🇳🇫", country: "Norfolk Island" },
  { code: "673", flag: "🇧🇳", country: "Brunei" },
  { code: "674", flag: "🇳🇷", country: "Nauru" },
  { code: "675", flag: "🇵🇬", country: "Papua New Guinea" },
  { code: "676", flag: "🇹🇴", country: "Tonga" },
  { code: "677", flag: "🇸🇧", country: "Solomon Islands" },
  { code: "678", flag: "🇻🇺", country: "Vanuatu" },
  { code: "679", flag: "🇫🇯", country: "Fiji" },
  { code: "680", flag: "🇵🇼", country: "Palau" },
  { code: "681", flag: "🇼🇫", country: "Wallis and Futuna" },
  { code: "682", flag: "🇨🇰", country: "Cook Islands" },
  { code: "683", flag: "🇳🇺", country: "Niue" },
  { code: "685", flag: "🇼🇸", country: "Samoa" },
  { code: "686", flag: "🇰🇮", country: "Kiribati" },
  { code: "687", flag: "🇳🇨", country: "New Caledonia" },
  { code: "688", flag: "🇹🇻", country: "Tuvalu" },
  { code: "689", flag: "🇵🇫", country: "French Polynesia" },
  { code: "690", flag: "🇹🇰", country: "Tokelau" },
  { code: "691", flag: "🇫🇲", country: "Micronesia" },
  { code: "692", flag: "🇲🇭", country: "Marshall Islands" },
  { code: "850", flag: "🇰🇵", country: "North Korea" },
  { code: "852", flag: "🇭🇰", country: "Hong Kong" },
  { code: "853", flag: "🇲🇴", country: "Macau" },
  { code: "855", flag: "🇰🇭", country: "Cambodia" },
  { code: "856", flag: "🇱🇦", country: "Laos" },
  { code: "880", flag: "🇧🇩", country: "Bangladesh" },
  { code: "886", flag: "🇹🇼", country: "Taiwan" },
  { code: "960", flag: "🇲🇻", country: "Maldives" },
  { code: "961", flag: "🇱🇧", country: "Lebanon" },
  { code: "962", flag: "🇯🇴", country: "Jordan" },
  { code: "963", flag: "🇸🇾", country: "Syria" },
  { code: "964", flag: "🇮🇶", country: "Iraq" },
  { code: "965", flag: "🇰🇼", country: "Kuwait" },
  { code: "966", flag: "🇸🇦", country: "Saudi Arabia" },
  { code: "967", flag: "🇾🇪", country: "Yemen" },
  { code: "968", flag: "🇴🇲", country: "Oman" },
  { code: "970", flag: "🇵🇸", country: "Palestine" },
  { code: "971", flag: "🇦🇪", country: "United Arab Emirates" },
  { code: "972", flag: "🇮🇱", country: "Israel" },
  { code: "973", flag: "🇧🇭", country: "Bahrain" },
  { code: "974", flag: "🇶🇦", country: "Qatar" },
  { code: "975", flag: "🇧🇹", country: "Bhutan" },
  { code: "976", flag: "🇲🇳", country: "Mongolia" },
  { code: "977", flag: "🇳🇵", country: "Nepal" },
  { code: "992", flag: "🇹🇯", country: "Tajikistan" },
  { code: "993", flag: "🇹🇲", country: "Turkmenistan" },
  { code: "994", flag: "🇦🇿", country: "Azerbaijan" },
  { code: "995", flag: "🇬🇪", country: "Georgia" },
  { code: "996", flag: "🇰🇬", country: "Kyrgyzstan" },
  { code: "998", flag: "🇺🇿", country: "Uzbekistan" },
]

export const parentTestimonials = [
  {
    image: parentImage1,
    text: "...this has been the best update ever, it’s been hugely motivating, please keep expanding it!",
    quotee: "Amanda E, parent of child with ODD",
  },
  {
    image: parentImage2,
    text: "...this new AI pet chat feature is amazing! My son is very resistant to writing in any form. Hand or digital. Ever since I turned on the chat feature he is typing up a STORM to talk to his doters!",
    quotee: "Sabrina C, parent of child with ADHD",
  },
  {
    image: parentImage3,
    text: "I enabled the new communication feature with the Pet last night and my daughter absolutely loved it when she opened the app this morning!",
    quotee: "Mark L, parent of child with ADHD",
  },
]

export const parentReferralTestimonials = [
  {
    image: parentImage1,
    text: "I love Joon because, with Joon, the reward is the game. It's not buying them things or giving them money to stay motivated to listen, help around the house, and most importantly, develop a sense of independence!",
    quotee: "Sophie M.",
  },
  {
    image: parentReferralImage1,
    text: "Not only is Joon helping my kids focus and stay on top of their morning routine, its also teaching them to care for others. It's just such a great life skill that I never thought an 8 year old could develop.",
    quotee: "Jamie F.",
  },
  {
    image: parentReferralImage2,
    text: "There is no reason for this app to be limited to simple things like chores. Any task you need your children to focus on can be added and they will rush to do it! Within 5 minutes of introducing it to my kids they were running back and forth completing quests and asking me for more!",
    quotee: "Lucy R.",
  },
  {
    image: parentReferralImage3,
    text: "The best part about Joon is the part that removes the fighting and tension between me and my son. No longer do I need to hound him to focus and stay on top of his to dos, the app does it for me!",
    quotee: "Megan W.",
  },
  {
    image: parentReferralImage4,
    text: "My son uses Joon every week. It's been great in motivating him to develop positive habits like brushing his teeth and becoming a more well-rounded individual.",
    quotee: "Nick B.",
  },
  {
    image: parentReferralImage5,
    text: "All of my kids use Joon. It helps motivate them to do their homework, chores, and keep physically fit! These are things I could never convince them to do on my own.",
    quotee: "Charlotte M.",
  },
]

export const prepaywallQuestions = [
  {
    question: "Do you relate to the statement below?",
    subtitle: "",
    imageText:
      "“I feel like I have to remind my kid ten times before anything actually gets done”",
    image: reminderImage,
  },
  {
    question: "Do you relate to the statement below?",
    subtitle: "",
    imageText:
      "“No matter what charts or rewards I try, nothing seems to motivate my child consistently”",
    image: motivationImage,
  },
  {
    question: "Do you relate to the statement below?",
    subtitle: "",
    imageText:
      "“By the time I manage everything for my child, I have no energy left for myself”",
    image: energyImage,
  },
  {
    question: "Joon is here for you!",
    subtitle: "Say hello 👋 to calm and stress-free home!",
    imageText: "",
    image: completionImage,
  },
]

export const pauseOptions = [
  { label: "1 month", value: 1 },
  { label: "2 months", value: 2 },
  { label: "3 months", value: 3 },
]

export const screenTimeFTUXItems = [
  {
    icon: faBullseyeArrow,
    title: "Choose which apps to lock on their iOS and/or Android device",
    description:
      "Decide which apps your child can earn time for and for how long.",
  },
  {
    icon: faUnlock,
    title: "Approve requests & Track Usage",
    description:
      "Get notified and approve unlock requests, and see how many minutes spent per app.",
  },
  {
    icon: faPartyHorn,
    title: "Earned, Not Demanded:",
    description:
      "Kids feel empowered to earn screen time, while you stay in the loop—no surprises!",
  },
]

export const isVercelDeployment =
  window.location.hostname.endsWith(".vercel.app")
